import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-monitor",
  "use": "icon-monitor-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-monitor\"><defs><style type=\"text/css\">@font-face { font-family: feedback-iconfont; src: url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.woff2?t=1630033759944\") format(\"woff2\"), url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.woff?t=1630033759944\") format(\"woff\"), url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.ttf?t=1630033759944\") format(\"truetype\"); }\r\n</style></defs><path d=\"M1004.495238 760.685714H19.504762v-682.666666h984.990476v682.666666z m-887.466667-97.523809h789.942858v-487.619048H117.028571v487.619048zM204.8 848.457143h619.27619v97.523809H204.8z\" p-id=\"5423\" /><path d=\"M380.342857 604.647619L297.447619 482.742857l-97.523809 73.142857-58.514286-78.019047L316.952381 341.333333l63.390476 87.771429 131.657143-204.8 141.409524 160.914286 58.514286-87.771429 170.666666 68.266667-34.133333 92.647619-102.4-39.009524-82.895238 126.780952-136.533334-160.914285z\" p-id=\"5424\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/monitor.svg
// module id = Lu+8
// module chunks = 80